import { motion } from 'framer-motion';

export const AnimatedRoute = ({ children, duration = 0.5 }) => {
  return (
    <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
};

export const AnimatedRouteQuestion = ({ children }) => {
    return (
        <motion.div
              initial={{ opacity: 0, x: 150, scale: 0.9 }} // Nová otázka začíná mimo obrazovku napravo
              animate={{ opacity: 1, x: 0, scale: 1 }} // Animace vstupu, fade-in a posun do středu
              exit={{ opacity: 0, x: -150, scale: 0.9 }} // Při odchodu fade-out a sklouzne doleva
              transition={{ duration: 0.5, ease: 'easeInOut' }} // Hladký přechod s trváním 0.5s
        >
            {children}
        </motion.div>
    );
};

export const AnimatedRouteScore = ({ children }) => {
  return (
    <motion.div
        initial={{ scale: 4 }}
        animate={{ scale: 1, transition: { type: 'spring', stiffness: 500, damping: 70 } }}
        exit={{ scale: 2 }}
        transition={{ duration: 0.8, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
};

export const AnimatedHeader = ({ children }) => {
  return (
    <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1, transition: { type: 'spring', stiffness: 500, damping: 70 }  }}
        exit={{ y: 50, opacity: 0 }}
        transition={{ duration: 0.8, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
};




